module.exports = __webpack_public_path__ + "static/media/Reed Nelson.9cc7397f.jpg";